// todo: Этот файл не нужен наверно

document.addEventListener('DOMContentLoaded', () => {
  const CART_UPDATE_URI = '/cart/update';

  $(document).on('click', '#updateSummary', (e) => {
    e.preventDefault();
    const input = $(e.currentTarget);
    const itemCard = input.closest('[data-cart-product-id]');
    // let totalPrice = input.closest('[data-cart-product-id]');
    const productId = itemCard.data('cartProductId');
    const count = parseFloat(input.val());

    /** @type {{ productId: number; count: number }} */
    const data = {
      productId,
      count,
    };

    window.promiseQueue.add('change-cart', () => {
      window.axios
        .get(CART_UPDATE_URI, data)
        .then((response) => {
          itemCard.find('.card-order-total-container').replaceWith(response?.itemSummaryContent);
          document.updateCartIcon(response?.cartItemCount);
          document.updateCartSummary();
        })
        .catch((error) => {
          document.modalMessageErrorShow();
          // eslint-disable-next-line no-console
          console.warn(error);
        });
    });
  });
});
